import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

import { createStructuredSelector } from 'reselect';
import injectReducer from 'utils/injectReducer';
import { connect } from 'react-redux';
import { compose } from 'redux';
import reducer from 'containers/Quotation/reducer';

import { makeSelectOriginalOffer } from 'containers/Quotation/selectors';
import { featureAllowed } from 'containers/App/selectors';
import messages from './messages';
import './styles.scss';
import 'antComponentsStyle';

class QuotationInitializer extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.storeOfferConfiguration();
  }

  componentDidUpdate() {
    this.storeOfferConfiguration();
  }

  storeOfferConfiguration() {
    let {
      offer,
      price,
      accessories,
      selectedColors,
      services,
      equippedOptionals,
      fees,
    } = this.props;

    if (accessories.hasOwnProperty('__altered')) {
      accessories = accessories.toArray();
    }

    if (selectedColors.hasOwnProperty('__altered')) {
      selectedColors = selectedColors.toArray();
    }

    if (services && services.hasOwnProperty('__altered')) {
      services = services.toArray();
    }

    offer.code = this.props.originalOffer.code;
    offer.car = this.props.originalOffer.car;
    offer.images = this.props.originalOffer.images;
    offer.tag = this.props.originalOffer.tag;
    offer.secondaryTag = this.props.originalOffer.secondaryTag;

    const objToStorage = {
      offer,
      price,
      accessories: this.props.originalOffer.optionalAccessories.data,
      selectedAccessories: accessories,
      colors: this.props.originalOffer.colors.data,
      selectedColors: selectedColors,
      selectedServices: services,
      equippedOptionals,
      fees,
    };

    localStorage.setItem('lastConfiguredOffer', JSON.stringify(objToStorage));
  }

  render() {
    if (this.props.featureAllowed('quotations')) {
      return (
        <Link to="/quotation/" id="QuotationInitializer">
          <Button
            className="mx-auto"
            type="primary"
            size="large"
          >
            <FormattedMessage {...messages.button} />
          </Button>
        </Link>
      );
    } else {
      return (
        <Button
          className="mx-auto"
          type="primary"
          size="large"
          disabled={true}
        >
          <FormattedMessage {...messages.button} />
        </Button>
      );
    }
  }
}

const mapStateToProps = createStructuredSelector({
  originalOffer: makeSelectOriginalOffer(),
  featureAllowed: (state, featureSlug) => featureAllowed(state, featureSlug),
});
const withReducer = injectReducer({ key: 'quotation', reducer });

const withConnect = connect(mapStateToProps);

export default compose(
  withReducer,
  withConnect,
)(QuotationInitializer);
